import { render, staticRenderFns } from "./GlobalPanorama.vue?vue&type=template&id=1665bc15&"
import script from "./GlobalPanorama.vue?vue&type=script&lang=ts&"
export * from "./GlobalPanorama.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports